import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export type BadgeTone =
  | "solid"
  | "soft"
  | "neutral"
  | "purple"
  | "success"
  | "warning"
  | "danger";

const TONES: Record<BadgeTone, string> = {
  solid: "bg-brand-cyan text-white",
  soft: "bg-accent text-accent-foreground",
  neutral: "bg-surface-raised text-muted-foreground",
  purple:
    "bg-violet-100 text-violet-700 dark:bg-violet-500/20 dark:text-violet-200",
  success:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  warning:
    "bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300",
  danger: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300",
};

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

/** Small rounded pill label (role, status, points…). */
export function Badge({ tone = "soft", children, icon, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-semibold whitespace-nowrap",
        TONES[tone],
        className
      )}
    >
      {icon}
      {children}
    </span>
  );
}

export default Badge;
